import { useContext } from "react";
import styles from "./styles.module.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { FaturamentoContext } from "./FaturamentoContext";
import logo from "../../images/logoAzulPrincipal.png";
import { Button } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const ViewExportPdf = ({ reference, exportPDF, onClose, footerTotalRef }) => {
  const { dados, somaEmpresas } = useContext(FaturamentoContext);

  const handleFormatCell = (cell, type) => {
    const formatNumber = () => {
      let valorFormatado = Number(cell).toFixed(2).replace(".", ",");
      return (valorFormatado = valorFormatado.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      ));
    };
    switch (true) {
      case cell === true:
        return "Sim";
      case cell === false:
        return "Não";
      case cell instanceof Date:
        return cell.toLocaleDateString("pt-BR", { timeZone: "GMT" });
      case type === "porcentagem":
        return formatNumber() + " %";
      case type === "monetario":
        return "R$ " + formatNumber();
      case type === "numerico":
        return formatNumber();

      default:
        return cell;
    }
  };

  const cnpjs = somaEmpresas.unitario.map((item) => {
    return item.cnpj;
  });
  const tableView = cnpjs.map((cnpj) => {
    const listaAtual = dados.filter((itemAtual) => itemAtual.cnpj === cnpj);
    const valoresAtuais = somaEmpresas.unitario.filter(
      (empresa) => empresa.cnpj === cnpj
    );
    return (
      <div key={cnpj} data-pdf-avoid-break>
        <h4>{`${valoresAtuais[0].cnpj} - ${valoresAtuais[0].razaoSocial}`}</h4>
        <table className={styles.pdfTable}>
          <thead className={styles.pdfTHead}>
            <tr>
              <th>Serviço</th>
              <th>Dt. Fatura</th>
              <th>% Honorários</th>
              <th>Imposto</th>
              <th>Vl. Fatura</th>
              <th>Vl. Final Honorário</th>
              <th>Vl. IR</th>
              <th>Vl. PIS/ Cofins</th>
              <th>Vl. Csll</th>
              <th>Boleto</th>
              <th>Histórico Fatura</th>
            </tr>
          </thead>
          <tbody>
            {listaAtual.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item["servico"]}</td>
                  <td>{new Date(item["dtFatura"]).toLocaleDateString()}</td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(
                      item["percentualHonorarios"],
                      "porcentagem"
                    )}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["imposto"], "porcentagem")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["valorFatura"], "monetario")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["valorFinalHonorario"], "monetario")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["valorIR"], "monetario")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["valorCofins"], "monetario")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["valorCsll"], "monetario")}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {handleFormatCell(item["boleto"], "monetario")}
                  </td>
                  <td>{item["historicoFatura"]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className={styles.valoresTotais}>
          <h4>{`Valor Compensado: ${valoresAtuais[0].valorFatura?.replace(
            "R$",
            "R$ "
          )}`}</h4>
          <h4>{`Valor Empresa Honorário: ${valoresAtuais[0].valorFinalHonorario?.replace(
            "R$",
            "R$ "
          )}`}</h4>
          <hr />
        </div>
      </div>
    );
  });

  return (
    <>
      <div className={styles.pdfButtons}>
        <Button
          sx={{ color: "#18316e", borderColor: "#18316e" }}
          startIcon={<ArrowBackIosIcon />}
          variant="outlined"
          onClick={onClose}
        >
          Voltar
        </Button>
        <h4>Prévia PDF</h4>
        <Button
          endIcon={<PictureAsPdfIcon />}
          color="error"
          variant="outlined"
          onClick={exportPDF}
        >
          Exportar
        </Button>
      </div>
      <div>
        <hr />
      </div>
      <div ref={reference}>
        <div className={styles.pdfContainer}>
          <div className={styles.pdfHeader}>
            <h1>
              <TrendingUpIcon sx={{ marginRight: ".5rem" }} />
              Faturamento
            </h1>
            <img
              className={styles.pdfLogo}
              src={logo}
              alt="Logo azul da Taxation Mind"
            />
          </div>
          <div className={styles.pdfContent}>{tableView}</div>
          <div ref={footerTotalRef} className={styles.pdfFooterTotal} data-pdf-avoid-break>
            <h3>Valor Compensado Total: {somaEmpresas?.total}</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewExportPdf;
